import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_SHARE: GlameraIconDefinition = {
  name: 'share',
  viewBox: '0 0 24 24',
  svg: `
    <circle class="glm-share-node glm-share-node-top" cx="18" cy="5" r="3"></circle>
    <circle class="glm-share-node glm-share-node-left" cx="6" cy="12" r="3"></circle>
    <circle class="glm-share-node glm-share-node-bottom" cx="18" cy="19" r="3"></circle>
    <line class="glm-share-line glm-share-line-bottom" x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
    <line class="glm-share-line glm-share-line-top" x1="8.59" y1="10.49" x2="15.41" y2="6.51"></line>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-share-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './share.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ShareIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_SHARE;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
